import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DtoQuotation } from '@common';
import { MarkdownPipe } from '../../../../shared';

@Component({
  selector: 'app-content-quotation',
  imports: [CommonModule, MarkdownPipe],
  templateUrl: './content-quotation.component.html',
  styleUrls: ['./content-quotation.component.scss']
})
export class ContentQuotationComponent {
  //#region @Input/@Output/@ViewChild -----------------------------------------
  @Input() quotation?: DtoQuotation;
  //#endregion

  //#region getters/setters ---------------------------------------------------
  public get source(): string {
    return `(${this.quotation?.source})`;
  }
  //#endregion
}
